<template>
  <div
    class="questionnaire-progress-track"
    :aria-valuenow="clampedPercent"
    aria-valuemin="0"
    aria-valuemax="100"
    role="progressbar"
  >
    <div class="questionnaire-progress-fill" :style="{width: `${clampedPercent}%`}" />
  </div>
</template>

<script>
export default {
  name: "QuestionnaireProgressBar",
  props: {
    percent: {
      type: Number,
      required: true,
    },
  },
  computed: {
    clampedPercent() {
      if (!Number.isFinite(this.percent)) {
        return 0;
      }
      if (this.percent < 0) {
        return 0;
      }
      if (this.percent > 100) {
        return 100;
      }
      return this.percent;
    },
  },
  styleGuide: () => ({
    fillColor: { "color.font": "branded" },
  }),
};
</script>

<style scoped lang="scss">
.questionnaire-progress-track {
    width: 100%;
    height: 10px;
    background-color: #e8e8e8;
    border-radius: 999px;
    overflow: hidden;
}

.questionnaire-progress-fill {
    height: 100%;
    min-width: 10px;
    background-color: v-bind('$getStyles.fillColor');
    border-radius: 999px;
    transition: width 0.3s ease;
}
</style>
